module.exports = __webpack_public_path__ + "img/6.5df79f65.jpg";